<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon @click="back()">
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
						{{ $t("Edit Role") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<form-role
							v-model="item"
							:modules="permissions"
						></form-role>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Update") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import FormRole from "../../../forms/FormRole.vue";
export default {
	components: { FormRole },
	props: {
		role: Object,
		permissions: Object,
	},
	data() {
		return {
			item: this.$inertia.form(this.role),
		};
	},

	methods: {
		submit() {
			this.item.put(this.$route("central.roles.update", this.item.id));
		},

		onChangeTenant() {
			this.item.outlet_ids = [];
			this.$inertia.reload({
				only: ["permissions"],
				data: {
					tenant_id: this.item.tenant_id,
				},
			});
		},

		/**
		 * Back to previous page or to index page
		 *
		 * @return void
		 */
		back() {
			if (window.history.length > 2) {
				window.history.back();
			} else {
				this.$router.push({ name: "central.roles.index" });
			}
		},
	},
};
</script>